<template>
  <form @submit.prevent="submitForm">
    <FormField
      id="Clave"
      label="Clave"
      type="text"
      v-model="formData.Clave"
      :required="true"
      :maxlength="50"
      :disabled="isEditing"
      helpText="Clave única del estado"
    />
    
    <!-- Campo EmpresaId oculto - se captura automáticamente -->
    <input type="hidden" v-model="formData.EmpresaId" />
    
    <FormField
      id="PaisClave"
      label="Clave País"
      type="text"
      v-model="formData.PaisClave"
      :required="true"
      :maxlength="3"
      helpText="Clave del país (ej: MEX, USA)"
    />
    
    <FormField
      id="Nombre"
      label="Nombre"
      type="text"
      v-model="formData.Nombre"
      :required="true"
      :maxlength="200"
      helpText="Nombre del estado"
    />
    
    <FormField
      id="ClaveErp"
      label="Clave ERP"
      type="text"
      v-model="formData.ClaveErp"
      :maxlength="50"
      helpText="Clave en el sistema ERP"
    />
    
    <FormField
      id="Clave2"
      label="Clave 2"
      type="text"
      v-model="formData.Clave2"
      :maxlength="50"
      helpText="Clave secundaria"
    />
    
    <div class="d-flex gap-2 mt-4">
      <button type="button" class="btn btn-primary" :disabled="loading" @click="submitForm">
        <span v-if="loading" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
        <i v-else class="bi bi-save me-1"></i>
        {{ isEditing ? 'Actualizar' : 'Guardar' }}
      </button>
      <button type="button" class="btn btn-secondary" @click="$emit('cancel')">
        <i class="bi bi-x-circle me-1"></i> Cancelar
      </button>
    </div>
  </form>
</template>

<script>
import FormField from '@/shared/components/FormField.vue';
import empresaMixin from '@/shared/mixins/empresaMixin';

export default {
  name: 'CatEstadoForm',
  components: {
    FormField
  },
  mixins: [empresaMixin],
  props: {
    estado: {
      type: Object,
      default: () => ({
        Clave: '',
        EmpresaId: null,
        PaisClave: '',
        Nombre: '',
        ClaveErp: '',
        Clave2: ''
      })
    },
    isEditing: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formData: { ...this.estado }
    };
  },
  watch: {
    estado: {
      handler(newValue) {
        this.formData = { ...newValue };
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    submitForm() {
      // Asegurar que la empresa esté capturada antes de enviar
      this.ensureEmpresaCaptured();
      
      // Preparar datos para envío
      const dataToSubmit = { ...this.formData };
      
      this.$emit('submit', dataToSubmit);
    }
  }
};
</script>

<style scoped>
/* Estilos específicos del formulario si son necesarios */
</style>
